import React, { Component } from 'react';
import dcs_logo from './dcs_logo.png';
import UserScoreDualQuiz from './UserScoreDualQuiz';
import UserComponent from './UserComponent';
import UserScoreSingleQuiz from './UserScoreSingleQuiz';
import uuid from 'uuid/v4';
import Leaderboard from './Leaderboard';

let configs = {
    "reddit_internaltest2": (browserId) => new UserScoreDualQuiz("reddit_internaltest3_jan2017", browserId)
};

export default class UserScoreQuiz extends Component {
    constructor(props) {
        super(props);

        // Set up browser ID
        this.browserId = window.localStorage.getItem("browserId");
        if (!this.browserId) {
            this.browserId = uuid();
            window.localStorage.setItem("browserId", this.browserId);
        }

        // Set up name and scoredata
        var scoreData = window.localStorage.getItem("scoreData");
        try {
            scoreData = JSON.parse(scoreData);
        } catch(e) {
            scoreData = null;
        }
        let name = window.localStorage.getItem("name") || "";

        this.validationAnswer = window.localStorage.getItem("validationAnswer");

        // TODO
        this.configName = "reddit_internaltest2";

        this.quiz = configs[this.configName](this.browserId);
        this.quiz.loadLeaderboard((data) => {
            this.cachedLeaderboard = data;
        });

        this.state = {
            quiz_state: 'welcome', // welcome | loading_quiz | in_quiz | submitting_quiz | complete
            quiz_data: null,
            current_question: 0,
            score_data: scoreData,
            name: name,
            showLeaderboard: false
        };

        this.responses = [];

        setTimeout(() => {
            this.loadQuizData();
        }, 100);
    }

    loadQuizData() {
        this.quiz.loadQuizData(this.validationAnswer == null, (quizData) => {
            console.log("Quiz data loaded.");
            this.setState({ quiz_data: quizData });
            if (this.state.quiz_state == 'loading_quiz' || this.state.quiz_state == 'submitting_quiz') {
                this.setState({ quiz_state: 'in_quiz', current_question: 0, question_start_time: Date.now() });
            }
        });
    }

    beginQuiz(name) {
        this.setState({ name: name });
        window.localStorage.setItem("name", name);

        if (this.state.quiz_data == null) {
            // Wait for quiz data to load
            this.setState({ quiz_state: 'loading_quiz' });
        } else {
            this.setState({ quiz_state: 'in_quiz', current_question: 0, question_start_time: Date.now() });
        }
    }

    onResponse(score, points) {
        score["config_name"] = this.configName;
        score["elapsed"] = Date.now() - this.state.question_start_time;
        score["browser_id"] = this.browserId; 
        score["validation_answer"] = this.validationAnswer;

        let isValidation = score["item_id"] == "validation";
        if (isValidation) {
            // this is the validation question
            // just store response
            this.validationAnswer = score["response"];
            window.localStorage.setItem("validationAnswer", this.validationAnswer);
        }

        this.responses.push(score);

        if (this.state.current_question == this.state.quiz_data.length - 1) {
            // Quiz complete!
            this.submitQuiz(score, points);
        } else {
            // Submit interim response
            this.quiz.submitResponses(this.state.name, [score], points, (scoreData) => {
                // We don't display updated scoredata to hide which you got correct
                // but we do save.
                window.localStorage.setItem("scoreData", JSON.stringify(scoreData));

                console.log("Response submitted.");
            });

            this.setState({ current_question: this.state.current_question + 1, question_start_time: Date.now() });
        }
    }

    submitQuiz(finalResponse, finalPoints) {
        this.setState({ quiz_state: 'submitting_quiz', past_responses: this.responses });

        this.quiz.submitResponses(this.state.name, [finalResponse], finalPoints, (scoreData) => {
            console.log("Final response submitted. Loading more quiz.");
            this.responses = [];

            // first load a leaderboard to cache and show if user 
            this.cachedLeaderboard = null;
            this.quiz.loadLeaderboard((data) => {
                this.cachedLeaderboard = data;
                this.loadQuizData();
            });
            
            window.localStorage.setItem("scoreData", JSON.stringify(scoreData));
            this.setState({ score_data: scoreData });
        });
    }

    render() {
        var mainContent;
        var step = -1, stepTotal = -1;
        let showValidation = this.validationAnswer == null;

        if (this.state.quiz_state == 'welcome') {
            let WelcomeComponent = this.quiz.welcomeComponent();
            mainContent = <div>
                <WelcomeComponent
                showValidation={showValidation}
                onBegin={this.beginQuiz.bind(this)}
                name={this.state.name} />
                <div className="bottom-info">
                <a href="https://cs.toronto.edu" target="_blank" rel="noopener noreferrer"><img src={dcs_logo} /></a>
                <div>If you have questions or concerns about this website, please contact <a href="walleris@cs.toronto.edu">walleris@cs.toronto.edu</a></div>
                </div>
            </div>;
        } else if (this.state.quiz_state == 'loading_quiz') {
            mainContent = <div>Loading...</div>;
        } else if (this.state.quiz_state == 'in_quiz') {
            let QuestionComponent = this.quiz.questionComponent();
            mainContent = <QuestionComponent
                key={this.state.current_question}
                onResponse={this.onResponse.bind(this)}
                question={this.state.quiz_data[this.state.current_question]} />;
            step = this.state.current_question;
            stepTotal = this.state.quiz_data.length;

            if (this.state.current_question == 0 && this.state.past_responses) {
                let CompletionComponent = this.quiz.completionComponent();
                mainContent = <div>
                    <CompletionComponent responses={this.state.past_responses} />
                    {mainContent}
                </div>;
                step = -1; // Hide step counter
            }
        } else if (this.state.quiz_state == 'submitting_quiz') {
            let CompletionComponent = this.quiz.completionComponent();
            mainContent = <div>
                <CompletionComponent responses={this.state.past_responses} />
                <p>Loading more questions...</p>
            </div>;
        } 

        var progress;
        if (step != -1) {
            progress = <div className="progress">
                <div className="step">Step {step+1} / {stepTotal}</div>
                <div className="step-progress"><div style={{'width': ((step)*100/stepTotal) + "%"}}></div></div>
            </div>;
        }

        let scoreData = this.state.score_data;
        let score = <div className="score">
            <div className="user-score">Your score: <span>{scoreData ? scoreData.points : 0} points</span></div>
            {scoreData ? <div className="rank">#{scoreData.rank} in the world</div> : null}
            <div className="leaderboard-link" onClick={() => this.setState({showLeaderboard: !this.state.showLeaderboard})}>View Leaderboard</div>
        </div>;

        return <div className="quiz">
            <div className="top-bar">
                {this.state.quiz_state == 'welcome' ? <div className="title welcome-title">Welcome to the Reddit Specialist Quiz!</div> : <div className="title">Reddit Specialist Quiz</div>}
                {progress}
                {score}
            </div>
            <div className="main-content">
                <div className="inner">{mainContent}</div>
                {this.state.showLeaderboard ? <Leaderboard
                    onClose={() => this.setState({showLeaderboard: false})}
                    loader={(c) => {
                        if (this.state.quiz_state == "in_quiz") {
                            // use cached leaderboard to avoid giving away
                            if (this.cachedLeaderboard) {
                                c(this.cachedLeaderboard);
                            } else {
                                console.log("Could not show leaderboard, none cached");
                            }
                        } else {
                            this.quiz.loadLeaderboard(c);
                        }
                    }} /> : null}
            </div>
        </div>;
    }
}



// WEBPACK FOOTER //
// ./src/UserScoreQuiz.js